import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";
import { TransactionRequest } from "shared/models/transaction.model";

export const paymentSettingService = createApi({
  reducerPath: "paymentSettingService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getByPartner: builder.mutation<any, { partner_id: any }>({
      query: (params) => ({
        url: `/payment-setting/partner/${params?.partner_id}`,
        params,
        method: "GET",
        headers: {
          PageName: "Payment Settings",
        },
      }),
    }),
    saveByPartner: builder.mutation<any, any>({
      query: (body) => ({
        url: `/payment-setting/partner/${body.partner_id}`,
        body: body,
        method: "PUT",
        headers: {
          PageName: "Payment Setting",
        },
      }),
    }),
    getByMerchant: builder.mutation<any, {merchant_id: any }>({
      query: (params) => ({
        url: `/payment-setting/merchant/${params?.merchant_id}`,
        params,
        method: "GET",
        headers: {
          PageName: "Payment Settings",
        },
      }),
    }),
    saveByMerchant: builder.mutation<any, any>({
      query: (body) => ({
        url: `/payment-setting/merchant/${body?.merchant_id}`,
        body: body,
        method: "PUT",
        headers: {
          PageName: "Payment Setting",
        },
      }),
    }),
  }),
});

export const {
  useGetByPartnerMutation,
  useSaveByPartnerMutation,
  useGetByMerchantMutation,
  useSaveByMerchantMutation
} = paymentSettingService;
